const stringSortComparator = (c1, c2) => c1.localeCompare(c2);
const phoneNumberSortComparator = (c1, c2) => {
    return (c1 + '').replace(/\D/g,'').localeCompare((c2 + '').replace(/\D/g,''));
}

const parseIntSortComparator = (c1, c2) => {
    if( parseInt(c1) - parseInt(c2) === 0) {
        return c1 - c2;
    }
    return parseInt(c1) - parseInt(c2);
}

// "Houston, TX 77777", degrading cleanly as parts go missing rather than
// printing "null" / "undefined". city, state and zip are all nullable on
// customers, and the state code is a lookup that misses when state_id is null.
const formatCityStateZip = (city, stateCode, zipCode) => {
    const stateAndZip = [stateCode, zipCode].filter(Boolean).join(' ');
    return [city, stateAndZip].filter(Boolean).join(', ');
}

const exports = {
    stringSortComparator,
    phoneNumberSortComparator,
    parseIntSortComparator,
    formatCityStateZip,
};

export default exports;
export {
    stringSortComparator,
    phoneNumberSortComparator,
    parseIntSortComparator,
    formatCityStateZip,
};
